export const COMPANY = {
  name: "Jahzara Phenix Jae Orion LLC",
  short: "Jahzara Phenix",
  established: 2022,
  domain: "jahzaraphenix.com",
  tagline: "AI Asset Holding & Intelligent Enterprise Ecosystem",
  logo: "/crest-emblem.png",
  luchiiMark: "/luchii-mark.png",
};

export const NAV_LINKS = [
  { label: "Heritage", href: "#heritage" },
  { label: "Asset Portfolio", href: "#portfolio" },
  { label: "Products", href: "#products" },
  { label: "AI Intelligence", href: "#intelligence" },
  { label: "Contact", href: "#contact" },
];

export const REALMS = [
  { name: "Earth", role: "The Stabilizer", desc: "Stability · grounding · structure", use: "Business logic, planning" },
  { name: "Mars", role: "The Challenger", desc: "Ambition · exploration · expansion", use: "Creativity, ideation" },
  { name: "Europa", role: "The Seer", desc: "Clarity · precision · insight", use: "Technical reasoning" },
  { name: "Titan", role: "The Guardian", desc: "Resilience · endurance · protection", use: "Safety, compliance" },
  { name: "Meta", role: "The Unifier", desc: "Unity · synthesis · federation", use: "Multi-domain synthesis" },
];

export const HERITAGE = [
  { year: "2022", title: "Foundation", desc: "Jahzara Phenix Jae Orion LLC is established as an AI holding company." },
  { year: "2023", title: "Luchii Acquisition", desc: "The Luchii multi-tier transformer family joins the portfolio as the generative core." },
  { year: "2024", title: "Frasberg Integration", desc: "Frasberg enterprise agentic frameworks added as the decision & risk core." },
  { year: "2026", title: "The Era of Harmony", desc: "Constellation Layer unifies all realms into a single unified intelligence." },
];
